const clearResults = (state, action, initialState) => ({
  ...state,
  results: undefined,
  tabs: initialState.tabs,
  loading: action.payload.loading || false,
});

export default clearResults;
